module.exports = __webpack_public_path__ + "img/product_04.da0a27d2.png";